import styled from 'styled-components';

export const Paragraph = styled.p<{ align?: string }>`
    font-size: 16px;
    font-weight: 300;
    line-height: 18px;
    text-align: ${(props) => props.align || 'left'};
    padding-bottom: 12px;
`;
